import { useContext } from "react";
import { AppShell, Box, Drawer, Stack } from "@mantine/core";
import { HEADER_HEIGHT } from "../utils/constants";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useDisclosure } from "@mantine/hooks";
import { AuthContext } from "../contexts/AuthContext";
import Logo from "../components/Logo";
import LinkMsAccountBanner from "../components/LinkMsAccountBanner";
import MsLinkResultModal from "../components/MsLinkResultModal";
import { LayoutOffsetProvider } from "../contexts/LayoutOffsetContext";

function Layout({ children }) {
  const { isAuthenticated, user } = useContext(AuthContext);
  const [sidebarOpened, { toggle: toggleSidebar }] = useDisclosure();
  const [drawerOpened, { toggle: toggleDrawer }] = useDisclosure();

  return (
    <LayoutOffsetProvider>
      <AppShell
        header={{ height: HEADER_HEIGHT }}
        navbar={{
          width: sidebarOpened ? 180 : 60,
          breakpoint: "md",
          collapsed: {
            desktop: !isAuthenticated,
            mobile: true,
          },
        }}
      >
        <AppShell.Header>
          <Header toggleSidebar={toggleSidebar} toggleDrawer={toggleDrawer} />
          <Drawer
            opened={drawerOpened}
            onClose={toggleDrawer}
            withCloseButton={false}
            size="xs"
            hiddenFrom="md"
            styles={{
              body: {
                backgroundColor: "var(--mantine-color-body)",
              },
            }}
          >
            <Stack h="calc(100vh - 35px)">
              <Box p="sm">
                <Logo
                  showTitle
                  subLabel={user?.isStaff ? "Admin" : undefined}
                />
              </Box>
              <Sidebar opened />
            </Stack>
          </Drawer>
        </AppShell.Header>
        <AppShell.Navbar>
          <Sidebar opened={sidebarOpened} />
        </AppShell.Navbar>
        <AppShell.Main>
          <LinkMsAccountBanner />
          {children}
        </AppShell.Main>
        <MsLinkResultModal />
      </AppShell>
    </LayoutOffsetProvider>
  );
}

export default Layout;
